import { SET_PWA_APPBAR_BACKLINK } from '../constants';

const INITIAL_STATE = {
  pwaAppbarBackLink: null
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_PWA_APPBAR_BACKLINK:
      return {
        ...state,
        pwaAppbarBackLink: action.payload
      };
    default:
      return state;
  }
}
